export const capacitySelectors = {
  row: {
    header: {
      menuTrigger: 'capacities-row-header-menu-trigger',
      menuItemOrders: 'capacities-row-header-menu-item-orders',
      menuItemPeople: 'capacities-row-header-menu-item-people',
    },
    curve: {
      bar: 'capacities-row-curve-bar',
      barBorder: 'capacities-row-curve-bar-border',
      barHitbox: 'capacities-row-curve-bar-hitbox',
      line: 'capacities-row-curve-line',
      pill: 'capacities-row-curve-pill',
      pillBorder: 'capacities-row-curve-pill-border',
      pillHitbox: 'capacities-row-curve-pill-hitbox',
      tooltip: 'capacities-row-curve-tooltip',
    },
  },
};
